'use client';

export { ActiveCampaignProvider, useActiveSkin } from './ActiveCampaignProvider';
export { useCampaignCategory, withoutCampaignCategory } from './hooks/useCampaignCategory';
export type { CampaignCategorySpot } from './hooks/useCampaignCategory';
export { useCampaignLogo } from './hooks/useCampaignLogo';
export { useCampaignShop } from './hooks/useCampaignShop';
export { useHasCampaignIllustration, useIllustration } from './hooks/useIllustration';
export { illustrationVideoSources, isFramedIllustration } from '@/libs/campaigns/illustrations';
export type { CampaignId } from '@/libs/campaigns/registry';
export type { IllustrationSlotName } from '@/libs/campaigns/types';
